export function isCellVisible(index: number, visibleProductIndex: number, isMobile: boolean) {
  if (isMobile) {
    return visibleProductIndex === index
  }

  return true
}
